// extracted by mini-css-extract-plugin
module.exports = {"ShoppingCartInquiry":"VenueShoppingCartInquryContent_ShoppingCartInquiry__Fz6p7","responsiveContainer":"VenueShoppingCartInquryContent_responsiveContainer__8WY_v"};